import padStart from 'lodash/padStart';
import { defineComponent, ref, getCurrentInstance } from 'vue-demi';
import { onClickOutside } from '@vueuse/core';
import { s as script$2 } from './OrFloating-00617713.js';
import { s as script$3 } from './OrLabel-a7d99df4.js';
import { s as script$4 } from './OrError-f90296db.js';
import { s as script$5 } from './OrHint-8822005b.js';
import { s as script$6 } from './OrCollapse-fdd7efab.js';
import './OrButton-bc9cc4a5.js';
import { s as script$7 } from './OrIconButton-5ccfcc6f.js';
import { n as setStyle, r as requestAF, t as getCS, b as reflow, c as cancelAF } from './dom-53c9635b.js';
import { p as pxToRem } from './px-to-rem-0b26b83e.js';
import { openBlock, createElementBlock, normalizeClass, withModifiers, toDisplayString, resolveComponent, createBlock, withCtx, renderSlot, createTextVNode, createCommentVNode, createElementVNode, createVNode, Transition, Fragment, renderList, withDirectives, vModelText, pushScopeId, popScopeId } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var OrDateTimePickerTypes;
(function (OrDateTimePickerTypes) {
  OrDateTimePickerTypes["date"] = "date";
  OrDateTimePickerTypes["time"] = "time";
  OrDateTimePickerTypes["dateTime"] = "dateTime";
})(OrDateTimePickerTypes || (OrDateTimePickerTypes = {}));
var OrDateTimePickerItemTypes;
(function (OrDateTimePickerItemTypes) {
  OrDateTimePickerItemTypes["day"] = "day";
  OrDateTimePickerItemTypes["hours"] = "hours";
  OrDateTimePickerItemTypes["minutes"] = "minutes";
})(OrDateTimePickerItemTypes || (OrDateTimePickerItemTypes = {}));
const DEFAULT_TEXT = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  hours: 'Hours',
  minutes: 'Minutes'
};

var script$1 = defineComponent({
  name: 'OrDateTimePickerCalendarItem',
  props: {
    value: {
      type: Date,
      required: false,
      default: () => new Date()
    },
    type: {
      type: String,
      required: false,
      default: () => OrDateTimePickerItemTypes.day
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    isCurrent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    valueToShow() {
      var _a, _b, _c;
      switch (this.type) {
        case OrDateTimePickerItemTypes.day:
          return '' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.getDate());
        case OrDateTimePickerItemTypes.hours:
          return padStart('' + ((_b = this.value) === null || _b === void 0 ? void 0 : _b.getHours()), 2, '0');
        case OrDateTimePickerItemTypes.minutes:
          return padStart('' + ((_c = this.value) === null || _c === void 0 ? void 0 : _c.getMinutes()), 2, '0');
        default:
          throw new Error('Unknown type');
      }
    },
    rootClasses() {
      return {
        'is-disabled': this.isDisabled,
        'is-selected': this.isSelected,
        'is-current': this.isCurrent
      };
    }
  },
  methods: {
    select() {
      if (this.isDisabled) return;
      this.$emit('select', this.value);
    }
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-calendar-item", _ctx.rootClasses]),
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.select && _ctx.select(...args), ["prevent"]))
  }, toDisplayString(_ctx.valueToShow), 3 /* TEXT, CLASS */);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-799ce784 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-799ce784 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-calendar-item[data-v-799ce784] {\n  width: 1.75rem;\n  height: 1.75rem;\n  font-size: var(--fs-0);\n  font-weight: normal;\n  line-height: 1.75rem;\n  color: var(--c-neutral-6);\n  text-align: center;\n  border-radius: 50%;\n}\n.or-calendar-item.is-disabled[data-v-799ce784] {\n  color: var(--c-neutral-4);\n}\n.or-calendar-item.is-current[data-v-799ce784] {\n  background-color: var(--c-neutral-2);\n}\n.or-calendar-item:not(.is-disabled).is-selected[data-v-799ce784] {\n  font-weight: bold;\n  color: var(--c-neutral-0);\n  background-color: var(--c-primary);\n}\n.or-calendar-item:not(.is-disabled).is-selected[data-v-799ce784]:hover {\n  background-color: var(--c-primary-lighten-20);\n}\n.or-calendar-item[data-v-799ce784]:not(.is-disabled):hover {\n  cursor: pointer;\n  background-color: var(--c-neutral-1);\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-799ce784";
script$1.__file = "src/components/or-date-time-picker/partials/OrDateTimePickerCalendarItem.vue";

const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
var script = defineComponent({
  name: 'OrDateTimePicker',
  components: {
    OrDateTimePickerCalendarItem: script$1,
    OrFloating: script$2,
    OrLabel: script$3,
    OrError: script$4,
    OrHint: script$5,
    OrCollapse: script$6,
    OrIconButton: script$7
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Date,
      required: false,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: () => OrDateTimePickerTypes.dateTime
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    error: {
      type: String,
      required: false,
      default: ''
    },
    hint: {
      type: String,
      required: false,
      default: ''
    },
    translations: {
      type: Object,
      required: false,
      default: () => DEFAULT_TEXT
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false
    },
    isFullwidth: {
      type: Boolean,
      required: false,
      default: false
    },
    dateFilter: {
      type: Function,
      required: false,
      default: null
    },
    allowSeconds: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['update:modelValue'],
  setup() {
    const content = ref();
    const wrapperRef = ref();
    const isOpen = ref(false);
    onClickOutside(content, evt => {
      if (evt.composedPath().includes(wrapperRef.value)) return;
      if (isOpen.value) isOpen.value = false;
    });
    return {
      content,
      wrapperRef,
      isOpen
    };
  },
  data() {
    return {
      isFocused: false,
      reqAF: null,
      monthToShow: new Date().getMonth(),
      yearToShow: new Date().getFullYear()
    };
  },
  computed: {
    inputHours: {
      get: function () {
        if (!this.modelValue) return '';
        return padStart('' + this.modelValue.getHours(), 2, '0');
      },
      set: function (val) {
        var _a;
        let hours = +val;
        hours = hours >= 24 ? 23 : hours < 0 ? 0 : hours;
        const date = (_a = this.modelValue) !== null && _a !== void 0 ? _a : this.today;
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, date.getMinutes(), date.getSeconds());
        this.$emit('update:modelValue', newDate);
      }
    },
    inputMinutes: {
      get: function () {
        if (!this.modelValue) return '';
        return padStart('' + this.modelValue.getMinutes(), 2, '0');
      },
      set: function (val) {
        var _a;
        let minutes = +val;
        minutes = minutes >= 60 ? 59 : minutes < 0 ? 0 : minutes;
        const date = (_a = this.modelValue) !== null && _a !== void 0 ? _a : this.today;
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), minutes, date.getSeconds());
        this.$emit('update:modelValue', newDate);
      }
    },
    inputSeconds: {
      get: function () {
        if (!this.modelValue) return '';
        return padStart('' + this.modelValue.getSeconds(), 2, '0');
      },
      set: function (val) {
        var _a;
        let seconds = +val;
        seconds = seconds >= 60 ? 59 : seconds < 0 ? 0 : seconds;
        const date = (_a = this.modelValue) !== null && _a !== void 0 ? _a : this.today;
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), seconds);
        this.$emit('update:modelValue', newDate);
      }
    },
    localId() {
      var _a, _b;
      return (_a = this.id) !== null && _a !== void 0 ? _a : `date-time-picker-${(_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.uid}`;
    },
    dateValue() {
      if (!this.modelValue) return '';
      const year = padStart('' + this.modelValue.getFullYear(), 4, '0');
      const month = padStart('' + (this.modelValue.getMonth() + 1), 2, '0');
      const day = padStart('' + this.modelValue.getDate(), 2, '0');
      return `${year}-${month}-${day}`;
    },
    timeValue() {
      if (!this.modelValue) return '';
      const hours = padStart('' + this.modelValue.getHours(), 2, '0');
      const minutes = padStart('' + this.modelValue.getMinutes(), 2, '0');
      if (this.isShowSeconds) {
        const seconds = padStart('' + this.modelValue.getSeconds(), 2, '0');
        return `${hours}:${minutes}:${seconds}`;
      }
      return `${hours}:${minutes}`;
    },
    isInactive() {
      return this.isDisabled || this.isReadonly;
    },
    isShowError() {
      return !!this.error && this.isInvalid;
    },
    isShowHint() {
      return !!this.hint && !this.isShowError;
    },
    isShowInfo() {
      return this.isShowError || this.isShowHint;
    },
    isShowDate() {
      return this.type === OrDateTimePickerTypes.date || this.type === OrDateTimePickerTypes.dateTime;
    },
    isShowTime() {
      return this.type === OrDateTimePickerTypes.time || this.type === OrDateTimePickerTypes.dateTime;
    },
    isShowSeconds() {
      return this.isShowTime && this.allowSeconds;
    },
    today() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    firstDayOfMonth() {
      return new Date(this.yearToShow, this.monthToShow, 1);
    },
    lastDayOfMonth() {
      return new Date(this.yearToShow, this.monthToShow + 1, 0);
    },
    calendar() {
      const start = new Date(this.yearToShow, this.monthToShow, 1 - (this.firstDayOfMonth.getDay() + 6) % 7);
      const end = new Date(this.yearToShow, this.monthToShow + 1, (7 - this.lastDayOfMonth.getDay()) % 7);
      const daysToShow = (+end - +start) / DAY;
      const rowsCount = daysToShow / 7; // week
      const calendar = [];
      const startMonthYear = start.getFullYear();
      const startMonthMonth = start.getMonth();
      const startMonthDay = start.getDate();
      for (let i = 0; i < rowsCount; i++) {
        const row = [];
        for (let j = 0; j < 7; j++) {
          const offset = j + i * 7;
          const current = new Date(startMonthYear, startMonthMonth, startMonthDay + offset);
          row.push(current);
        }
        calendar.push(row);
      }
      return calendar;
    },
    hours() {
      const rowsCount = 4;
      const columnsCount = 24 / rowsCount;
      const zeroDate = new Date(0);
      const hours = [];
      for (let i = 0; i < rowsCount; i++) {
        const row = [];
        for (let j = 0; j < columnsCount; j++) {
          const hour = new Date(zeroDate.getFullYear(), zeroDate.getMonth(), zeroDate.getDate(), j + i * columnsCount);
          row.push(hour);
        }
        hours.push(row);
      }
      return hours;
    },
    minutes() {
      const rowsCount = 4;
      const step = 5;
      const columnsCount = 60 / step / rowsCount;
      const zeroDate = new Date(0);
      const minutes = [];
      for (let i = 0; i < rowsCount; i++) {
        const row = [];
        for (let j = 0; j < columnsCount; j++) {
          const minute = new Date(zeroDate.getFullYear(), zeroDate.getMonth(), zeroDate.getDate(), 0, step * (j + i * columnsCount));
          row.push(minute);
        }
        minutes.push(row);
      }
      return minutes;
    },
    typeClass() {
      switch (this.type) {
        case OrDateTimePickerTypes.date:
          return 'is-date-type';
        case OrDateTimePickerTypes.time:
          return 'is-time-type';
        case OrDateTimePickerTypes.dateTime:
          if (this.allowSeconds) return 'is-date-time-type-seconds';
          return 'is-date-time-type';
        default:
          throw new Error('Unknown type');
      }
    },
    rootClasses() {
      return [this.typeClass, ...(this.isFullwidth ? ['is-fullwidth'] : [])];
    },
    wrapperClasses() {
      return {
        'is-disabled': this.isDisabled,
        'is-readonly': this.isReadonly,
        'is-focused': this.isFocused,
        'is-required': this.isRequired,
        'has-error': this.isInvalid
      };
    }
  },
  methods: {
    isDayDisabled(date) {
      const res = +date < +this.firstDayOfMonth || +date > +this.lastDayOfMonth;
      if (this.dateFilter) {
        return this.dateFilter(date) || res;
      }
      return res;
    },
    isDaySelected(date) {
      if (!this.modelValue) return false;
      const selectedDay = new Date(this.modelValue.getFullYear(), this.modelValue.getMonth(), this.modelValue.getDate());
      return +date >= +selectedDay && +date < +selectedDay + DAY;
    },
    isHourSelected(date) {
      if (!this.modelValue) return false;
      return this.modelValue.getHours() === date.getHours();
    },
    isMinuteSelected(date) {
      if (!this.modelValue) return false;
      return this.modelValue.getMinutes() === date.getMinutes();
    },
    beforeEnter(el) {
      setStyle(el, 'opacity', 0);
    },
    enter(el) {
      const {
        scrollHeight,
        parentElement
      } = el;
      this.reqAF = requestAF(() => {
        const pt = parseFloat(getCS(parentElement).paddingTop);
        const pb = parseFloat(getCS(parentElement).paddingBottom);
        const height = scrollHeight + pt + pb;
        if (parentElement) {
          reflow(parentElement);
          setStyle(parentElement, 'height', pxToRem(height));
        }
        setStyle(el, 'opacity', 1);
      });
    },
    leave(el) {
      this.reqAF = requestAF(() => {
        el.style.opacity = '0';
      });
    },
    cancelRequestAF() {
      cancelAF(this.reqAF);
    },
    toggle() {
      var _a;
      if (this.isInactive) return;
      this.isOpen = !this.isOpen;
      const dateToShow = (_a = this.modelValue) !== null && _a !== void 0 ? _a : new Date();
      this.monthToShow = dateToShow.getMonth();
      this.yearToShow = dateToShow.getFullYear();
    },
    decrementMonth() {
      this.monthToShow--;
      if (this.monthToShow < 0) {
        this.monthToShow = 11;
        this.yearToShow--;
      }
    },
    incrementMonth() {
      this.monthToShow++;
      if (this.monthToShow >= 12) {
        this.monthToShow = 0;
        this.yearToShow++;
      }
    },
    handleDaySelect(date) {
      var _a, _b;
      if (this.type === OrDateTimePickerTypes.date) {
        this.$emit('update:modelValue', date);
      } else {
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), ((_a = this.modelValue) !== null && _a !== void 0 ? _a : date).getHours(), ((_b = this.modelValue) !== null && _b !== void 0 ? _b : date).getMinutes());
        this.$emit('update:modelValue', newDate);
      }
    },
    handleHourSelect(date) {
      var _a;
      const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), ((_a = this.modelValue) !== null && _a !== void 0 ? _a : date).getMinutes());
      this.$emit('update:modelValue', newDate);
    },
    handleMinuteSelect(date) {
      var _a;
      const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), ((_a = this.modelValue) !== null && _a !== void 0 ? _a : date).getHours(), date.getMinutes());
      this.$emit('update:modelValue', newDate);
    }
  }
});

const _withScopeId = n => (pushScopeId("data-v-733cf0b2"), n = n(), popScopeId(), n);
const _hoisted_1 = ["id", "value", "disabled", "readonly"];
const _hoisted_2 = {
  key: 0,
  class: "placeholder"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "value"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "or-date-time-picker-info"
};
const _hoisted_10 = {
  ref: "content",
  class: "content"
};
const _hoisted_11 = {
  class: "picker-header"
};
const _hoisted_12 = {
  class: "calendar"
};
const _hoisted_13 = {
  class: "calendar-week-days"
};
const _hoisted_14 = {
  class: "calendar-days"
};
const _hoisted_15 = {
  key: 0,
  class: "time-footer"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("span", null, ":", -1 /* HOISTED */));
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1,
  class: "time-table"
};
const _hoisted_19 = {
  class: "time-table-column"
};
const _hoisted_20 = {
  class: "picker-header"
};
const _hoisted_21 = {
  class: "picker-header-centered"
};
const _hoisted_22 = {
  class: "time-table-column-time"
};
const _hoisted_23 = {
  class: "time-table-column"
};
const _hoisted_24 = {
  class: "picker-header"
};
const _hoisted_25 = {
  class: "picker-header-centered"
};
const _hoisted_26 = {
  class: "time-table-column-time"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_label = resolveComponent("or-label");
  const _component_or_hint = resolveComponent("or-hint");
  const _component_or_error = resolveComponent("or-error");
  const _component_or_collapse = resolveComponent("or-collapse");
  const _component_or_icon_button = resolveComponent("or-icon-button");
  const _component_or_date_time_picker_calendar_item = resolveComponent("or-date-time-picker-calendar-item");
  const _component_or_floating = resolveComponent("or-floating");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-date-time-picker", _ctx.rootClasses])
  }, [_ctx.$slots['label-default'] || _ctx.label ? (openBlock(), createBlock(_component_or_label, {
    key: 0,
    "is-required": _ctx.isRequired,
    for: _ctx.localId
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "label-default", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])]),
    append: withCtx(() => [renderSlot(_ctx.$slots, "label-append")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["is-required", "for"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    ref: "wrapperRef",
    class: normalizeClass(["or-date-time-picker-input-wrapper", _ctx.wrapperClasses]),
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["prevent"]))
  }, [createElementVNode("input", {
    id: _ctx.localId,
    type: "hidden",
    value: _ctx.modelValue,
    disabled: _ctx.isDisabled,
    readonly: _ctx.isReadonly
  }, null, 8 /* PROPS */, _hoisted_1), !_ctx.modelValue ? (openBlock(), createElementBlock("div", _hoisted_2, [_ctx.isShowDate ? (openBlock(), createElementBlock("div", _hoisted_3, " YYYY-MM-DD ")) : createCommentVNode("v-if", true), _ctx.isShowTime ? (openBlock(), createElementBlock("div", _hoisted_4, [createTextVNode(" HH:MM"), _ctx.isShowSeconds ? (openBlock(), createElementBlock("span", _hoisted_5, ":SS")) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true)])) : (openBlock(), createElementBlock("div", _hoisted_6, [_ctx.isShowDate ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(_ctx.dateValue), 1 /* TEXT */)) : createCommentVNode("v-if", true), _ctx.isShowTime ? (openBlock(), createElementBlock("div", _hoisted_8, toDisplayString(_ctx.timeValue), 1 /* TEXT */)) : createCommentVNode("v-if", true)]))], 2 /* CLASS */), createVNode(_component_or_collapse, {
    "is-visible": _ctx.isShowInfo
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_9, [createVNode(Transition, {
      mode: "out-in",
      onBeforeEnter: _ctx.beforeEnter,
      onEnter: _ctx.enter,
      onAfterEnter: _ctx.cancelRequestAF,
      onLeave: _ctx.leave,
      onAfterLeave: _ctx.cancelRequestAF
    }, {
      default: withCtx(() => [_ctx.isShowHint ? (openBlock(), createBlock(_component_or_hint, {
        key: _ctx.hint,
        hint: _ctx.hint,
        class: "or-date-time-picker-hint"
      }, null, 8 /* PROPS */, ["hint"])) : createCommentVNode("v-if", true)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onBeforeEnter", "onEnter", "onAfterEnter", "onLeave", "onAfterLeave"]), createVNode(Transition, {
      mode: "out-in",
      onBeforeEnter: _ctx.beforeEnter,
      onEnter: _ctx.enter,
      onAfterEnter: _ctx.cancelRequestAF,
      onLeave: _ctx.leave,
      onAfterLeave: _ctx.cancelRequestAF
    }, {
      default: withCtx(() => [_ctx.isShowError ? (openBlock(), createBlock(_component_or_error, {
        key: _ctx.error,
        error: _ctx.error,
        class: "or-date-time-picker-error"
      }, null, 8 /* PROPS */, ["error"])) : createCommentVNode("v-if", true)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onBeforeEnter", "onEnter", "onAfterEnter", "onLeave", "onAfterLeave"])])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible"]), _ctx.isOpen ? (openBlock(), createBlock(_component_or_floating, {
    key: 1,
    trigger: _ctx.wrapperRef,
    offset: 4,
    placement: "bottom-start",
    "is-using-flip": "",
    "is-using-shift": ""
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_10, [_ctx.isShowDate ? (openBlock(), createElementBlock(Fragment, {
      key: 0
    }, [createElementVNode("div", _hoisted_11, [createVNode(_component_or_icon_button, {
      icon: "keyboard_arrow_left",
      "icon-color": "neutral-6",
      onClick: _ctx.decrementMonth
    }, null, 8 /* PROPS */, ["onClick"]), createElementVNode("div", null, toDisplayString(_ctx.translations.months[_ctx.monthToShow]) + " " + toDisplayString(_ctx.yearToShow), 1 /* TEXT */), createVNode(_component_or_icon_button, {
      icon: "keyboard_arrow_right",
      "icon-color": "neutral-6",
      onClick: _ctx.incrementMonth
    }, null, 8 /* PROPS */, ["onClick"])]), createElementVNode("div", _hoisted_12, [createElementVNode("div", _hoisted_13, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.translations.days, day => {
      return openBlock(), createElementBlock("div", {
        key: day
      }, toDisplayString(day), 1 /* TEXT */);
    }), 128 /* KEYED_FRAGMENT */))]), createElementVNode("div", _hoisted_14, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.calendar, (row, index) => {
      return openBlock(), createElementBlock("div", {
        key: index,
        class: "calendar-days-row"
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(row, day => {
        return openBlock(), createBlock(_component_or_date_time_picker_calendar_item, {
          key: +day,
          value: day,
          type: "day",
          "is-current": +day === +_ctx.today,
          "is-disabled": _ctx.isDayDisabled(day),
          "is-selected": _ctx.isDaySelected(day),
          onSelect: _ctx.handleDaySelect
        }, null, 8 /* PROPS */, ["value", "is-current", "is-disabled", "is-selected", "onSelect"]);
      }), 128 /* KEYED_FRAGMENT */))]);
    }), 128 /* KEYED_FRAGMENT */))])]), _ctx.isShowTime ? (openBlock(), createElementBlock("div", _hoisted_15, [withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.inputHours = $event),
      type: "number",
      class: normalizeClass(["time-footer-input", {
        'time-footer-input-tripple': _ctx.isShowSeconds
      }]),
      placeholder: "00"
    }, null, 2 /* CLASS */), [[vModelText, _ctx.inputHours]]), _hoisted_16, withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.inputMinutes = $event),
      type: "number",
      class: normalizeClass(["time-footer-input", {
        'time-footer-input-tripple': _ctx.isShowSeconds
      }]),
      placeholder: "00"
    }, null, 2 /* CLASS */), [[vModelText, _ctx.inputMinutes]]), _ctx.isShowSeconds ? (openBlock(), createElementBlock("span", _hoisted_17, ":")) : createCommentVNode("v-if", true), _ctx.isShowSeconds ? withDirectives((openBlock(), createElementBlock("input", {
      key: 1,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.inputSeconds = $event),
      type: "number",
      class: normalizeClass(["time-footer-input", {
        'time-footer-input-tripple': _ctx.isShowSeconds
      }]),
      placeholder: "00"
    }, null, 2 /* CLASS */)), [[vModelText, _ctx.inputSeconds]]) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("div", _hoisted_18, [createElementVNode("div", _hoisted_19, [createElementVNode("div", _hoisted_20, [createElementVNode("span", _hoisted_21, toDisplayString(_ctx.translations.hours), 1 /* TEXT */)]), createElementVNode("div", _hoisted_22, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.hours, (row, index) => {
      return openBlock(), createElementBlock("div", {
        key: index,
        class: "time-table-column-time-row"
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(row, hour => {
        return openBlock(), createBlock(_component_or_date_time_picker_calendar_item, {
          key: +hour,
          value: hour,
          type: "hours",
          "is-selected": _ctx.isHourSelected(hour),
          onSelect: _ctx.handleHourSelect
        }, null, 8 /* PROPS */, ["value", "is-selected", "onSelect"]);
      }), 128 /* KEYED_FRAGMENT */))]);
    }), 128 /* KEYED_FRAGMENT */))])]), createElementVNode("div", _hoisted_23, [createElementVNode("div", _hoisted_24, [createElementVNode("span", _hoisted_25, toDisplayString(_ctx.translations.minutes), 1 /* TEXT */)]), createElementVNode("div", _hoisted_26, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.minutes, (row, index) => {
      return openBlock(), createElementBlock("div", {
        key: index,
        class: "time-table-column-time-row"
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(row, minute => {
        return openBlock(), createBlock(_component_or_date_time_picker_calendar_item, {
          key: +minute,
          value: minute,
          type: "minutes",
          "is-selected": _ctx.isMinuteSelected(minute),
          onSelect: _ctx.handleMinuteSelect
        }, null, 8 /* PROPS */, ["value", "is-selected", "onSelect"]);
      }), 128 /* KEYED_FRAGMENT */))]);
    }), 128 /* KEYED_FRAGMENT */))])])]))], 512 /* NEED_PATCH */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-733cf0b2 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-733cf0b2 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-date-time-picker[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.or-date-time-picker.is-fullwidth[data-v-733cf0b2] {\n  width: 100% !important;\n}\n.or-date-time-picker.is-date-type[data-v-733cf0b2] {\n  width: 7.125rem;\n}\n.or-date-time-picker.is-time-type[data-v-733cf0b2] {\n  width: 7.125rem;\n}\n.or-date-time-picker.is-date-time-type[data-v-733cf0b2] {\n  width: 11.25rem;\n}\n.or-date-time-picker.is-date-time-type-seconds[data-v-733cf0b2] {\n  width: 13.25rem;\n}\n.or-date-time-picker .or-label[data-v-733cf0b2] {\n  margin-bottom: var(--s-1);\n}\n.or-date-time-picker-info[data-v-733cf0b2] {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-top: var(--s-2);\n}\n.or-date-time-picker-input-wrapper[data-v-733cf0b2] {\n  position: relative;\n  width: 100%;\n  height: 2.25rem;\n  padding: 0.625rem;\n  font-size: var(--fs-1);\n  line-height: 1rem;\n  background-color: var(--c-neutral-1);\n  border: 1px solid var(--c-neutral-2);\n  border-radius: var(--s-2);\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: border-color, background-color, -webkit-box-shadow;\n}\n.or-date-time-picker-input-wrapper[data-v-733cf0b2]:not(.is-readonly):hover {\n  cursor: pointer;\n  background-color: var(--c-neutral-0);\n}\n.or-date-time-picker-input-wrapper[data-v-733cf0b2]:disabled, .or-date-time-picker-input-wrapper.is-disabled[data-v-733cf0b2] {\n  cursor: not-allowed;\n  background-color: var(--c-neutral-2);\n  border-color: var(--c-neutral-2);\n}\n.or-date-time-picker-input-wrapper.has-error[data-v-733cf0b2] {\n  border-color: var(--c-error);\n}\n@media (hover: hover) and (pointer: fine) {\n.or-date-time-picker-input-wrapper.has-error[data-v-733cf0b2]:not(.or-date-time-picker-input-wrapper.has-error.is-loading):not(.or-date-time-picker-input-wrapper.has-error.is-disabled):not(.or-date-time-picker-input-wrapper.has-error.is-readonly):not(.or-date-time-picker-input-wrapper.has-error:disabled):not(.or-date-time-picker-input-wrapper.has-error.is-focused):not(.or-date-time-picker-input-wrapper.has-error:active):hover {\n    border-color: var(--c-error-darken-3);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.or-date-time-picker-input-wrapper.has-error[data-v-733cf0b2]:not(.or-date-time-picker-input-wrapper.has-error.is-loading):not(.or-date-time-picker-input-wrapper.has-error.is-disabled):not(.or-date-time-picker-input-wrapper.has-error.is-readonly):not(.or-date-time-picker-input-wrapper.has-error:disabled):not(.or-date-time-picker-input-wrapper.has-error.is-focused):not(.or-date-time-picker-input-wrapper.has-error:active):hover {\n    border-color: var(--c-error-darken-3);\n}\n}\n.or-date-time-picker-input-wrapper.has-error[data-v-733cf0b2]:not(:disabled):not(.is-readonly):not(.is-loading):focus {\n  border-color: var(--c-error-darken-5);\n}\n.or-date-time-picker-input-wrapper.has-error[data-v-733cf0b2]:disabled, .or-date-time-picker-input-wrapper.has-error.is-disabled[data-v-733cf0b2] {\n  cursor: not-allowed;\n  border-color: var(--c-error-lighten-20);\n}\n.or-date-time-picker-input-wrapper .placeholder[data-v-733cf0b2],\n.or-date-time-picker-input-wrapper .value[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  white-space: nowrap;\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: opacity;\n}\n.or-date-time-picker-input-wrapper .placeholder[data-v-733cf0b2] {\n  color: var(--c-neutral-4);\n  user-select: none;\n}\n.content[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  background-color: var(--c-neutral-0);\n  border: 1px solid var(--c-neutral-2);\n  border-radius: var(--s-2);\n}\n.content .picker-header[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--s-3);\n  justify-content: space-between;\n  padding: var(--s-4) var(--s-3);\n  font-size: var(--fs-1);\n  font-weight: bold;\n  color: var(--c-neutral-6);\n  text-align: center;\n}\n.content .picker-header-centered[data-v-733cf0b2] {\n  margin: auto;\n}\n.content .calendar[data-v-733cf0b2] {\n  padding: 0 var(--s-3) var(--s-3);\n  font-size: var(--fs-0);\n  line-height: 0.875rem;\n}\n.content .calendar-week-days[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: var(--s-1);\n  color: var(--c-neutral-4);\n}\n.content .calendar-week-days > *[data-v-733cf0b2] {\n  width: var(--s-6);\n}\n.content .calendar-days[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--s-2);\n}\n.content .calendar-days-row[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--s-2);\n  justify-content: space-around;\n}\n.content .time-footer[data-v-733cf0b2] {\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  line-height: var(--s-6);\n  text-align: center;\n  border-top: 1px solid var(--c-neutral-2);\n}\n.content .time-footer input[data-v-733cf0b2]::-webkit-outer-spin-button,\n.content .time-footer input[data-v-733cf0b2]::-webkit-inner-spin-button {\n  margin: 0;\n  -webkit-appearance: none;\n}\n.content .time-footer input[type=number][data-v-733cf0b2] {\n  -moz-appearance: textfield;\n}\n.content .time-footer-input[data-v-733cf0b2] {\n  font-size: var(--fs-0);\n  text-align: center;\n  border: none;\n}\n.content .time-footer-input-tripple[data-v-733cf0b2] {\n  max-width: 96px;\n}\n.content .time-footer-input[data-v-733cf0b2]:focus-visible {\n  background-color: var(--c-neutral-2);\n  outline: none;\n}\n.content .time-table[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--s-4);\n}\n.content .time-table-column[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: column;\n}\n.content .time-table-column-time[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--s-2);\n  padding: 0 var(--s-3) var(--s-3);\n}\n.content .time-table-column-time-row[data-v-733cf0b2] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--s-2);\n  justify-content: space-around;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-733cf0b2";
script.__file = "src/components/or-date-time-picker/OrDateTimePicker.vue";

export { DEFAULT_TEXT as D, OrDateTimePickerTypes as O, OrDateTimePickerItemTypes as a, script as s };
